import React, { useState } from 'react';
import { Box, Button, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Tooltip } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight, FactCheck, Assessment } from '@mui/icons-material';
import CustomDropDown from '../../CustomDropDown';
import CustomTextField from '../../CustomTextField';
import Loader from '../../Loader';
import { headingBlue, lightGrey, maroon, mediumGrey } from '../../../assets/colors';
import { tableOffsets } from '../../../utils/constants';
import BatchAttendanceDialog from './BatchAttendanceDialog';
import BatchAssessmentResultsDialog from './BatchAssessmentResultsDialog';

import moment from 'moment';
import HttpService from '../../../backend/requestApis';
import { fetchTrainingBatches } from '../../../backend/backendApis';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import EditBatchDialog from './EditBatchDialog';

function TrainingBatchTable(props) {
    const [attendanceDialogStatus, setAttendanceDialogStatus] = useState(false);
    const [assessmentResultsDialogStatus, setAssessmentResultsDialogStatus] = useState(false);
    const [selectedBatchId, setSelectedBatchId] = useState(null);
    const [selectedBatchDetails, setSelectedBatchDetails] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [editDialogStatus, setEditDialogStatus] = useState(false);
    const [editData, setEditData] = useState(null);

    var outerBoxStyle = {
        width: '100%',  
        height: '70vh',
        marginTop: "0.4rem"
    };
    
    var paperStyle = {
        border: '1px solid #D9D9D9',
        padding: "0.2rem 0.1rem 0.1rem 0.1rem",
    };

    var headerBoxStyle = {
        display: 'flex',
        padding: "0.3rem",
        flexWrap: 'wrap'
    };
    
    var internalBoxStyle = {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '20%',
        flex: '0.25 1',
        flexDirection: "row",
        flexWrap: 'wrap'
    };

    var typographyStyle = {
        marginLeft: "0.5rem",
        padding: "0.1rem",
        fontSize: "1rem",
        fontWeight: "600"
    };

    var buttonStyle = {
        backgroundColor: headingBlue,
        color: 'white',
        marginLeft: "0.7rem",
        fontFamily: "Helvetica",
        fontWeight: '300',
        fontSize: '0.9rem',
        padding: "0.2rem 1rem 0.2rem 1rem",
        textTransform: 'capitalize'
    };

    var headerCellStyle = {
        padding: '0.2rem 0.5rem 0.1rem 0.5rem', 
        fontFamily: "Helvetica",
        fontSize: "1rem", 
        fontWeight: "400",
        textAlign: 'center',
    };

    const openAttendanceDialog = (row) => {
        setSelectedBatchId(row._id || row.batchId);
        setSelectedBatchDetails(row);
        setAttendanceDialogStatus(true);
    };

    const openAssessmentResultsDialog = (row) => {
        setSelectedBatchId(row._id || row.batchId);
        setSelectedBatchDetails(row);
        setAssessmentResultsDialogStatus(true);
    };

    const openEditDialog = (row, e) => {
        if (e) e.stopPropagation();
        setEditData(row);
        setEditDialogStatus(true);
    };

    const updateEditDialogStatus = (status, refresh = false) => {
        setEditDialogStatus(status);
        if (refresh && props.updatePage) {
            props.updatePage(props.pageValue);
        }
    };

    const handleDownload = () => {
        setIsDownloading(true);
        let options = {
            url: fetchTrainingBatches,
            method: 'GET',
            params: {
                page: 1,
                offset: props?.data?.totalRecords || 10000,
                search: props.filterByValue
            },
            headers: {
                Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
            }
        };

        HttpService(options).then((resp) => {
            let records = resp?.data?.data?.data || [];
            
            const transformedData = records.map(row => {
                return {
                    'Batch Name': row.batchName || '-',
                    'Unique Id': row.uniqueId || '-',
                    'Start Date': row.startDate ? moment(row.startDate).utcOffset('+05:30').format('DD/MM/YYYY') : '-',
                    'End Date': row.endDate ? moment(row.endDate).utcOffset('+05:30').format('DD/MM/YYYY') : '-',
                    'Volunteer Name and CN': row.volunteerName ? `${row.volunteerName} - ${row.volunteerCN}` : '-',
                    'Members': row.members && Array.isArray(row.members) ? row.members.length : (row.members || '0'),
                    'Class Frequency': row.classFrequency && Array.isArray(row.classFrequency) ? row.classFrequency.join(', ') : (row.classFrequency || '-')
                };
            });

            const workBook = XLSX.utils.book_new();
            const workSheet = XLSX.utils.json_to_sheet(transformedData);
            XLSX.utils.book_append_sheet(workBook, workSheet, 'Batches');
            const excelBuffer = XLSX.write(workBook, {bookType: "xlsx", type: 'array'});
            const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
            saveAs(blob, 'Training_Batches.xlsx');
            setIsDownloading(false);
        }).catch(err => {
            console.log('Error downloading batches: ', err);
            setIsDownloading(false);
        });
    };

    return (
        <Box style={outerBoxStyle}>
            <Paper style={paperStyle}>
                <Box style={headerBoxStyle}>
                    <Box style={internalBoxStyle}>
                        <Typography style={typographyStyle}>Batches Table</Typography>
                    </Box>
                    <Box style={{ display:'flex', flex: "1 1", width: "80%", justifyContent: 'flex-end', padding: "0rem 0.5rem 0rem 0.5rem", flexWrap: 'wrap', gap: '0.5rem'}}>
                        <CustomTextField placeHolder="Enter Text to Filter" value={props.filterByValue} setFunc={props.updateFilterBy}></CustomTextField>
                        <Button variant='outlined' sx={buttonStyle} onClick={handleDownload} disabled={isDownloading}>{isDownloading ? 'Downloading...' : 'Download'}</Button>
                    </Box>
                </Box>
                
                <Box style={{display: 'flex', justifyContent: 'center', overflow: 'auto'}}>
                    <TableContainer component={Paper} style={{width: '98%', height: "55vh", border: '1px solid #D9D9D9', marginTop: "0.2rem", "&::-webkit-scrollbar": { display: 'none' }, scrollbarWidth: "none"}}>
                        <Table stickyHeader>
                            <TableHead style={{backgroundColor: mediumGrey}}>
                                <TableRow>
                                    <TableCell style={{...headerCellStyle, backgroundColor: lightGrey}}>
                                        <Box style={{color: headingBlue}}>Batch Name</Box>
                                    </TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: lightGrey}}>Unique Id</TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: lightGrey}}>start Date</TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: lightGrey}}>end Date</TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: lightGrey}}>volunteer Name and CN</TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: lightGrey}}>Members</TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: lightGrey}}>Class Frequency</TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: lightGrey}}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ textAlign: 'center', overflowY: 'auto'}}>
                                {props.isLoading && <Loader />}
                                {props?.data?.data?.map((row, index) => {
                                    return(
                                        <TableRow key={index} hover onClick={() => openEditDialog(row)} style={{ cursor: 'pointer' }}>
                                            <TableCell style={{...headerCellStyle, color: headingBlue, fontSize: '0.9rem'}}>
                                                {row.batchName ? row.batchName : '-'}
                                            </TableCell>
                                            <TableCell style={{...headerCellStyle, fontSize: '0.9rem'}}>
                                                {row.uniqueId ? row.uniqueId : '-'}
                                            </TableCell>
                                            <TableCell style={{...headerCellStyle, fontSize: '0.9rem'}}>
                                                {row.startDate ? moment(row.startDate).utcOffset('+05:30').format('DD/MM/YYYY') : '-'}
                                            </TableCell>
                                            <TableCell style={{...headerCellStyle, fontSize: '0.9rem'}}>
                                                {row.endDate ? moment(row.endDate).utcOffset('+05:30').format('DD/MM/YYYY') : '-'}
                                            </TableCell>
                                            <TableCell style={{...headerCellStyle, fontSize: '0.9rem'}}>
                                                {row.volunteerName ? `${row.volunteerName} - ${row.volunteerCN}` : '-'}
                                            </TableCell>
                                            <TableCell style={{...headerCellStyle, fontSize: '0.9rem'}}>
                                                {row.members && Array.isArray(row.members) ? row.members.length : (row.members || '0')}
                                            </TableCell>
                                            <TableCell style={{...headerCellStyle, fontSize: '0.9rem'}}>
                                                {row.classFrequency && Array.isArray(row.classFrequency) ? row.classFrequency.join(', ') : (row.classFrequency || '-')}
                                            </TableCell>
                                            <TableCell style={{...headerCellStyle, fontSize: '0.9rem'}}>
                                                <Box style={{display: 'flex', justifyContent: 'center', gap: '0.5rem'}}>
                                                    <Tooltip title="Attendance">
                                                        <IconButton 
                                                            size="small" 
                                                            style={{ color: headingBlue, padding: 0 }}
                                                            onClick={(e) => { e.stopPropagation(); openAttendanceDialog(row); }}
                                                        >
                                                            <FactCheck fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Assessment Results">
                                                        <IconButton 
                                                            size="small" 
                                                            style={{ color: headingBlue, padding: 0 }}
                                                            onClick={(e) => { e.stopPropagation(); openAssessmentResultsDialog(row); }}
                                                        >
                                                            <Assessment fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Edit">
                                                        <IconButton size="small" style={{ padding: 0 }} onClick={(e) => openEditDialog(row, e)}>
                                                            <img src={require('../../../assets/images/edit_icon.png')} alt="edit" style={{width: "18px", height: "18px", cursor: 'pointer'}} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                
                {/* Pagination Box */}
                <Box style={{display: 'flex', justifyContent: 'center', padding: "0.4rem 0rem 0.1rem 0rem"}}>
                    <Box style={{width: "30%", display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: "0rem 0.5rem 0rem 0.9rem"}}>
                        <Typography style={{color: maroon, fontSize: '0.9rem'}}>
                            {((props?.pageValue - 1) * props?.offsetValue) + 1} - {(props?.pageValue * props?.offsetValue) < (props?.data?.totalRecords) ? (props?.pageValue * props?.offsetValue) : props?.data?.totalRecords} of {props?.data?.totalRecords || 0}
                        </Typography>
                    </Box>
                    <Box style={{width: '40%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <IconButton size='small' onClick={() => props.pageValue > 1 && props.updatePage(props.pageValue - 1)} disabled={props.pageValue === 1}>
                            <KeyboardArrowLeft size='small' sx={{color: props.pageValue === 1 ? mediumGrey : headingBlue}} />
                        </IconButton>
                        
                        <Button variant='contained' style={{minWidth: '0rem', width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: headingBlue, color: 'white', padding: '0rem', alignItems: 'center'}}>
                            {props.pageValue || 1}
                        </Button>
                        
                        <IconButton size='small' onClick={() => props.pageValue < props?.data?.totalPages && props.updatePage(props.pageValue + 1)} disabled={props.pageValue === props?.data?.totalPages || !props?.data?.totalPages}>
                            <KeyboardArrowRight size='small' sx={{color: (props.pageValue === props?.data?.totalPages || !props?.data?.totalPages) ? mediumGrey : headingBlue}} />
                        </IconButton>
                    </Box>
                    <Box style={{width: '30%', display: 'flex', justifyContent: 'flex-end', padding: "0rem 0.6rem 0rem 0rem"}}>
                        <CustomDropDown key='table' value={props.offsetValue} width="5rem" setFunc={props.updateOffset} list={tableOffsets} regular={true} extraParamvalue={true}></CustomDropDown>
                    </Box>
                </Box>
                <BatchAttendanceDialog 
                    dialogStatus={attendanceDialogStatus} 
                    updateFunc={setAttendanceDialogStatus} 
                    batchId={selectedBatchId} 
                    batchDetails={selectedBatchDetails}
                />
                <BatchAssessmentResultsDialog 
                    dialogStatus={assessmentResultsDialogStatus} 
                    updateFunc={setAssessmentResultsDialogStatus} 
                    batchId={selectedBatchId} 
                    batchDetails={selectedBatchDetails}
                />
                <EditBatchDialog 
                    dialogStatus={editDialogStatus} 
                    updateFunc={updateEditDialogStatus} 
                    editData={editData} 
                />
            </Paper>
        </Box>
    )
}

export default TrainingBatchTable;
